import React from 'react';
import connect from "react-redux/es/connect/connect";
import { Link } from 'react-router';
import { Button, Popconfirm, message } from 'antd';
import { hashHistory } from 'react-router';

import { updateExistingEvent } from '../../../../services/firebase/events';
import { updateEventAction, deleteEventAction } from "../../../../actions/eventsStoreActions";

const EditButton = ({ 
  showEditButtons,
  entry,
  setVisible,
  loadingImportVideo ,
  updateEventAction,
  deleteEventAction,
  setStateHandler
}) => {
  const handleDeleteEvent = async (event) => {
    deleteEventAction(event).then((res) => {
      if (res === "success") {
        message.success('Event successful deleted');
        setStateHandler({markerLoading: false});
        hashHistory.push(`/Past_Events/Surgeries`);
      } else {
        message.error("Event didn't delete:", res);
        setStateHandler({markerLoading: false});
      }
    })
  };

  const updateEventChangeToPast = (entry) => {
    entry.isUpcoming = false;
    updateEvent(entry)
  };

  const updateEvent = async(values) => {
    await updateExistingEvent(values, 'past')
      .then(() => {
       updateEventAction(values);
      })
      .catch(err => {
        message.error(err);
        console.error('error', err);
      });
  }

  const cancel = () => {
    console.log('Canceled');
  };

  let content = null;

  if (showEditButtons) {
    content = (
      <div className="event-button">
        <Link to={`/Event_Editor/${entry.id}`}>
          <Button className="btn-warning">Edit Event</Button>
        </Link>

        <Button className="btn-danger">
          <Popconfirm
            title={`Are you sure delete this event - ${entry.title}?`}
            onConfirm={() => handleDeleteEvent(entry)}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <a href="#">Delete Event</a>
          </Popconfirm>
        </Button>

        {
          entry && entry.isUpcoming ? (
            <React.Fragment>
              <Popconfirm
                title={`Are you sure you want to remove the live embed for - ${entry.title}?`}
                onConfirm={() => updateEventChangeToPast(entry)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button className="btn">Finished Live Streaming?</Button>
              </Popconfirm>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Button onClick={() => setVisible(true)} loading={loadingImportVideo}>Ustream video manager</Button>
            </React.Fragment>
          )
        }
      </div>
    );
  }

  return content;
};

export default connect(null, { updateEventAction, deleteEventAction })(EditButton);


// WEBPACK FOOTER //
// ./src/components/Modules/Info/EditButton/index.js